var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:'uk-button uk-button-' + _vm.type,attrs:{"disabled":_vm.disabled || _vm.loading,"uk-tooltip":_vm.tooltip},on:{"click":function($event){return _vm.click()}}},[(_vm.loading)?_c('GL-Spinner',{staticClass:"uk-margin-small-right"}):_vm._e(),_c('span',{staticClass:"uk-text-nowrap"},[_vm._v(_vm._s(_vm.computedText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }